import { defineComponent as _defineComponent } from 'vue'
import BCXTable from '@/components/BCXTable.vue';
import { computed, PropType } from 'vue';
import useFormattedDateTime, { TimeFormatting } from '@/mixins/useFormattedDateTime';
import InvoicePositionsTableCell from '@/views/my-projects/components/invoice/positions/InvoicePositionsTableCell.vue';
import useUser from '@/mixins/useUser';
import downloadFile from '@/utils/downloadFile';
import useInvoice from '@/views/my-projects/composables/useInvoice';
import { AttachmentFile, InvoiceAttachment } from '@/models/Invoice';
import usePopupState from '@/state/usePopupState';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoiceAttachmentFileTable',
  props: {
  files: {
    type: Array as PropType< InvoiceAttachment[] >,
    required: true
  },
  isReduced: Boolean, // Is for display in invoices, under Received invoices
  currentTotalFileSize: {
    type: Number,
    required: false,
    default: 0
  }
},
  setup(__props) {

const props = __props;



const { getFormattedTimeByAge } = useFormattedDateTime();
const { tUserFallback: t } = useUser('self');
const {
  fetchAttachment, fetchDeleteAttachment, componentAttachmentsData, isAttachmentRequestRunning
} = useInvoice();
const { setPdf, showPopup } = usePopupState();

const fieldNames = computed(() => (props.isReduced ? ['position', 'filename'] : ['position', 'created', 'filename']));
const headerTitles = computed(() => fieldNames.value.map((fieldName) => t(`invoice.attachments.table.columns.${fieldName}_USERTYPE`)));
const filterFiles = computed(() => props.files.filter((file) => !(file.bInvoice && !props.isReduced)));

const sortCallback = (field: string, obj: any) => obj[field];

const displayCallback = (field: string, obj: any) => {
  if (field === 'created') {
    return getFormattedTimeByAge(obj.created, TimeFormatting.ChatMessageOverview);
  }
  return obj[field];
};

const progressDisplay = computed(() => ({
  labelBefore: t('invoice.attachments.table.totalSize'),
  currentSize: Number((props.currentTotalFileSize / 1000000).toFixed(1)),
  maxSize: 15,
  unit: 'MB',
  prepositionOrSeparators: t('invoice.attachments.table.by')
}));

async function onDownloadFile(file: InvoiceAttachment) {
  await fetchAttachment(0, file.id)
    .then((data: AttachmentFile) => {
      downloadFile(data.attachment, data.filename, data.fileType);
    });
}

async function onRemove(file: InvoiceAttachment) {
  await fetchDeleteAttachment(0, file.id)
    .then((data) => {
      componentAttachmentsData.value = data.attachments;
    });
}

async function onView(file: InvoiceAttachment) {
  showPopup();
  const { attachment, filename } = await fetchAttachment(0, file.id);
  setPdf(attachment, filename);
}

function isAttachmentPdf(file: InvoiceAttachment): boolean {
  return file.type === 'application/pdf';
}

return { __sfc: true,props, getFormattedTimeByAge, t, fetchAttachment, fetchDeleteAttachment, componentAttachmentsData, isAttachmentRequestRunning, setPdf, showPopup, fieldNames, headerTitles, filterFiles, sortCallback, displayCallback, progressDisplay, onDownloadFile, onRemove, onView, isAttachmentPdf, BCXTable, InvoicePositionsTableCell }
}

})